module.exports = __webpack_public_path__ + "down-arrow-dropdown.b7ac57c54be9e8779172.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin-icons/down-arrow-dropdown.svg
// module id = 147
// module chunks = 6